var exports = {
  "j": "ShowcaseSection__udK1eB",
};

module.exports = exports;
